// extracted by mini-css-extract-plugin
export default {"dropZone":"styles_dropZone__9Y4KW","icons":"styles_icons__TXMJB","dropZoneHighlight":"styles_dropZoneHighlight__Y2SKV","dropZoneError":"styles_dropZoneError__uL15m"};